export var Subject;
(function (Subject) {
    Subject["AgentEntity"] = "AgentEntity";
    Subject["AgentActivationStepEntity"] = "AgentActivationStepEntity";
    Subject["BusinessEntity"] = "BusinessEntity";
    Subject["BusinessMembershipEntity"] = "BusinessMembershipEntity";
    Subject["DeviceSessionEntity"] = "DeviceSessionEntity";
    Subject["MemberEntity"] = "MemberEntity";
    Subject["OtpEntity"] = "OtpEntity";
    Subject["UserEntity"] = "UserEntity";
    Subject["ChatEntity"] = "ChatEntity";
    Subject["AttachmentEntity"] = "AttachmentEntity";
    Subject["ChatMembershipStateEntity"] = "ChatMembershipStateEntity";
    Subject["ChatMembershipEntity"] = "ChatMembershipEntity";
    Subject["MessageReceiptEntity"] = "MessageReceiptEntity";
    Subject["MessageEntity"] = "MessageEntity";
    Subject["ReactMessageEntity"] = "ReactMessageEntity";
    Subject["TypingNotificationEntity"] = "TypingNotificationEntity";
    Subject["DeviceTokenEntity"] = "DeviceTokenEntity";
})(Subject || (Subject = {}));
//# sourceMappingURL=subject.const.js.map